import { Button, Center, MultiSelect, Select, TextInput } from "@mantine/core";
import { modals } from "@mantine/modals";

import SRD_Form from "components/Form";
import { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import { groupListState } from "components/Form/atom/groupListState";
import { popupUserListState } from "components/Form/atom/popupUserListState";
import Post from "components/Post";
import { getPopupUser } from "pages/Admin/User/apis/adminUserApis";
import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { getSiteList, insertSite } from "../apis/adminSiteApis";
import { PAGE_SIZE } from "CommonData";

function SiteAddForm() {
  const navigate = useNavigate();
  const [selectGroupId, setSelectGroupId] = useState();

  const [showPostModal, setShowPostModal] = useState(false);
  const [postResult, setPostResult] = useState();
  const [detailAddress, setDetailAddress] = useState();

  const [popupUserList, setPopupUserList] = useRecoilState(popupUserListState);

  const location = useLocation();
  let backPage = 1;
  if (location.state) {
    backPage = location.state.pg;
  }

  const backToList = () => {
    const params = new URLSearchParams({page: String(backPage)});
    navigate(`/admin/site?${params.toString()}`, {replace: true});
  };

  useEffect(() => {
    if (selectGroupId) {
      getPopupUser(selectGroupId).then((res) =>
        setPopupUserList(
          res.map((item) => ({
            value: item.user_id,
            label: item.fn_name,
          }))
        )
      );
    }
  }, [selectGroupId]);

  const handleButtonClick = () => {
    setShowPostModal(true);
  };

  const handleModalComplete = (data) => {
    setPostResult(data.address);
    setShowPostModal(false);
  };

  const handleModalCancel = () => {
    setShowPostModal(false);
  };

  const SearchAddress = (props) => {
    const { field, error } = props;

    return (
      <>
        <TextInput
          placeholder="주소"
          label="주소(직접 입력 시 상세주소창에 입력하세요)"
    //      required
          value={postResult}
          onClick={handleButtonClick}
          error={error}
        />
        <TextInput
          placeholder="상세 주소"
   //       disabled={postResult ? false : true}
          value={detailAddress}
          onChange={field.onChange}
        />
      </>
    );
  };

  const GroupSelect = (props) => {
    const { field, error } = props;

    const [groupList, setGroupList] = useRecoilState(groupListState);
    if (field.value !== undefined) setSelectGroupId(field.value);
    return (
      <>
        <Select
          label="그룹"
          required
          data={groupList}
          value={field.value}
          onChange={field.onChange}
          error={error}
        />
      </>
    );
  };

  const SiteManagerSelect = (props) => {
    const { field, name } = props;

    return (
      <>
        <MultiSelect
          label={name}
          data={popupUserList}
          value={field.value}
          onChange={field.onChange}
        />
      </>
    );
  };

  const fields = [
    {
      key: "group_id",
      name: "그룹",
      type: "etc",
      component: GroupSelect,
      options: "validate",
    },
    {
      key: "field_nm",
      name: "현장명",
      type: "text",
      options: "validate",
    },
    {
      key: "address",
      name: '주소',
      type: "etc",
      component: (props) => <SearchAddress {...props} />,
    },
    {
      key: "office_phone",
      name: "현장 연락처",
      type: "text",
      options: "validate",
    },
    {
      key: "users_id",
      name: "현장 담당자",
      type: "etc",
      component: SiteManagerSelect,
    },
    {
      key: "etc",
      name: "비고",
      type: "text",
    },
  ];

  const onSubmit = (e) => {
    const { users_id } = e;

    let multiSelectUsers = [];

    if (Array.isArray(users_id)) {
      multiSelectUsers = popupUserList.filter((popupUser) => {
        return users_id.indexOf(popupUser.value) !== -1;
      });
    }

    const users = multiSelectUsers.map((user) => user.value).join(",");
    const users_nm = multiSelectUsers.map((user) => user.label).join(",");

    const data = { ...e, users, users_nm };
    delete data.users_id;

    modals.openConfirmModal({
      title: "저장",
      children: <Center>저장 하시겠습니까?</Center>,
   //   centered: true,
      zIndex: 2000,
      labels: { confirm: "저장", cancel: "취소" },
      onConfirm: () => {
        insertSite(data, postResult)
          .then(() => getSiteList(PAGE_SIZE, 1))
          .catch((error) => console.log(error));
        backToList();
      },
    });
  };

  const SubmitButton = () => {
    return (
      <Center style={{ marginTop: "1rem" }}>
        <Button type="submit">저장</Button>
      </Center>
    );
  };

  return (
    <>
      <SRD_Form
        fields={fields}
        onSubmit={onSubmit}
        submitButton={<SubmitButton />}
      />
      {showPostModal && (
        <Post onComplete={handleModalComplete} onCancel={handleModalCancel} />
      )}
    </>
  );
}

export default SiteAddForm;
